import { WizardCustomer } from "models/wizard/WizardState";

export const getSalesPerson = (customer: WizardCustomer) => {
  const salesPerson = customer.internalUsers.filter(
    (user) => user.isSalePerson
  );

  if (salesPerson[0]) {
    return salesPerson[0].givenName + " " + salesPerson[0].surName;
  } else {
    return "-";
  }
};

export const getProjectOwners = (customer: WizardCustomer) => {
  const projectOwners = customer.internalUsers.filter(
    (user) => user.role === "ProjectOwner"
  );

  if (projectOwners.length > 0) {
    const userList: string[] = [];

    projectOwners.forEach((owner, index) => {
      userList.push(owner.givenName + " " + owner.surName);
    });
    return userList.join(", ");
  } else {
    return "-";
  }
};
